<template>
    <!-- 投递特权 -->
    <!-- 非会员 -->
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate==1||cvipMes.cvipstate==10)">
        <p class="des">特权介绍：<span class="des-in">心仪职位太多，每天申请次数不够用？非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！</span></p>
        <div class="tdtq-bg"><img class="tdtq-bg-img" src="https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"></div>
    </CvipDialog>
    <!-- 会员 -->
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1" v-else>
      <p class="tit">恭喜您，已获得<span  class="tit-names">投递翻倍</span>特权</p>
      <p class="des"><span class="des-in des-use">非会员每天只有15次全职职位申请机会，会员拥有25次全职职位申请机会，求职效率翻倍提升！</span></p>
      <div class="tdtq-bg"><img class="tdtq-bg-img" src="https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/r9o96ilm__w1068_h1108.png"></div>
    </CvipDialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import CvipDialog from "./common/CvipDialog"
    export default {
        name: 'tdtqDialog',
        components: {
            CvipDialog
        },
        data () {
            return {
                title: '投递翻倍',
                btnTxt: '开通会员尊享特权',
                title1: '',
                btnTxt1: '',
                title2: '',
                btnTxt2: '立即体验',
            }
        },
        created () {
            window.clickLog && window.clickLog(`from=pc-cvip-tdtq-tanchuang-show-${this.cvipMes.cvipstate}`)
        },
        methods: {
            // 点击支付按钮
            vipBuy () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-tdtq-ljkt-${this.cvipMes.cvipstate}`)
                this.$emit("buyDialog")
            },
            close () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-tdtq-close-${this.cvipMes.cvipstate}`)
                this.$emit("closeDialog")
            }
        },
        computed: mapGetters({
            cvipMes: 'cvipMes',
            rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
        })
    }

</script>

<style lang='scss' scoped>

    .tit{
        margin-top:80px;
    }
    .tdtq-bg{
        width: 606px;
        height: 290px;
        margin: 20px auto 0;
        overflow: hidden;
        text-align: center;
    }
    .tdtq-bg-img{
        // width: 606px;
        height: 290px;
    }
    .des-in{
        font-size: 14px;
        color: #AAAAAA;
    }
    .des-use{
        width:100%;
        display:inline-block;
        text-align:center;
    }
    .tit{
        margin: 55px 0 8px;
        font-size: 24px;
        color: #333;
        line-height: 33px;
        text-align:center;
    }
    .tit-names{
        font-size: 24px;
        color: #D4B277;
        line-height: 33px;
    }
</style>





// WEBPACK FOOTER //
// TdtqDialog.vue?37d99293